import { render, staticRenderFns } from "./ConnectWhatsapp.vue?vue&type=template&id=6f0c9f56"
import script from "./ConnectWhatsapp.vue?vue&type=script&lang=js"
export * from "./ConnectWhatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports